import { render, staticRenderFns } from "./GridItem.vue?vue&type=template&id=640f31be&scoped=true"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"
import style0 from "./GridItem.vue?vue&type=style&index=0&id=640f31be&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f31be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640f31be')) {
      api.createRecord('640f31be', component.options)
    } else {
      api.reload('640f31be', component.options)
    }
    module.hot.accept("./GridItem.vue?vue&type=template&id=640f31be&scoped=true", function () {
      api.rerender('640f31be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/browser/GridItem.vue"
export default component.exports